<template>
  <div>
    <general-top-bar :title="$t('reports.charismaReport')"></general-top-bar>
    <div class="col-md-12 card text-left">
      <div class="card-header" style="display:flex; justify-content: space-between; align-items:center;">
        <div>
          <p class="d-inline-flex">
            <a class="btn btn-orange back" @click.prevent="goBackToReport">
              <!-- <i class="ti-angle-left"></i> -->
              {{$t('general.back')}}
            </a>
          </p>
        </div>
        <div>
          <div class="text-right">
            <p class="d-inline-flex">
              <button 
                v-if="integration && integration.charisma_invoice_status != 0" 
                type="button" 
                class="btn btn-success btn-icon mar-rt-10 save" 
                @click.prevent="saveDetailsAndSendOrder(1)" 
                :title="$t('charisma.sendOnlyProform')"
              >
                {{$t('charisma.sendOnlyProform')}}
              </button>
              <button 
                v-if="integration && integration.charisma_invoice_status != 0" 
                type="button" 
                class="btn btn-success btn-icon mar-rt-10 save" 
                @click.prevent="saveDetailsAndSendOrder(2)" 
                :title="$t('charisma.sendOnlyInvoice')"
              >
                {{$t('charisma.sendOnlyInvoice')}}
              </button>
              <span v-if="integration && integration.charisma_invoice_status != 0" style="display: inline-block; width: 20px;"></span>
              <button type="button" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="saveDetailsAndSendOrder(0)" :title="$t('general.save')">
                <!-- <img src="/static/img/icons/save.png"> -->
                {{$t('general.saveAndSend')}}
              </button>
            </p>
          </div>
        </div>
      </div>
      <div class="card-content total-pagination pad-1">
        <h5 class="charisma-section-title">{{ $t('charisma.orderItems') }}</h5>
        <data-tables-server
          v-loading="loading"
          :data="items"
          :search-def="{ show: false }"
          :pagination-props="paginationProps"
          :table-props="tableOptions"
          ref="charismaTable"
          :key="tableKey"
          style="width: 100%;"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="options-wrapper">
                <el-table :data="props.row.options || []" size="mini" style="width: 100%">
                  <el-table-column prop="id" :label="$t('charisma.orderOptionId')" :min-width="120"></el-table-column>
                  <el-table-column prop="cov_id" :label="$t('charisma.companyOptionId')" :min-width="120"></el-table-column>
                  <el-table-column prop="option_name" :label="$t('charisma.optionName')" :min-width="200"></el-table-column>
                  <el-table-column prop="name" :label="$t('charisma.optionValueName')" :min-width="200"></el-table-column>
                  <el-table-column prop="cov_external_id" :label="$t('charisma.itemId')" :min-width="160">
                    <template slot-scope="props">
                      {{ props.row.cov_external_id ? props.row.cov_external_id : '-' }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('charisma.itemCode')" :min-width="160">
                    <template slot-scope="opt">
                      <el-input
                        size="mini"
                        v-model="opt.row.cov_pos_id"
                        :class="{ 'is-invalid': isOptionPosIdMissing(opt.row) }"
                        :placeholder="$t('charisma.enterItemCode')"
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" :min-width="40"></el-table-column>
          <el-table-column prop="c_id" :label="$t('reports.productId')" :min-width="60"></el-table-column>
          <el-table-column prop="name" :label="$t('reports.productName')" :min-width="160"></el-table-column>
          <el-table-column prop="category_name" :label="$t('catalogProd.category')" :min-width="120"></el-table-column>
          <el-table-column :label="$t('charisma.categoryAdministration')" :min-width="120">
            <template slot-scope="props">
              <div :class="{ 'is-invalid': isCategoryAdminInvalid(props.row) }">
                <el-select
                  size="small"
                  :value="categoryAdministrationByKey[getCategoryKey(props.row)] || props.row._category_admin || props.row.administration_id || null"
                  @change="onCategoryAdminChange(props.row, $event)"
                  :placeholder="$t('general.select')"
                  style="width: 100%"
                >
                  <el-option :label="$t('general.select')" :value="null" :key="'null'" />
                  <el-option
                    v-for="admin in administrations"
                    :label="admin.name"
                    :value="admin.id"
                    :key="admin.id"
                  />
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('charisma.itemId')" :min-width="60">
            <template slot-scope="props">
                {{ props.row.c_external_id ? props.row.c_external_id : '-' }}
              </template>
          </el-table-column>
          <el-table-column :label="$t('charisma.itemCode')" :min-width="100">
            <template slot-scope="props">
              <el-input
                v-model="props.row.c_pos_id"
                size="small"
                :class="{ 'is-invalid': isProductPosIdMissing(props.row) }"
                :placeholder="$t('charisma.enterItemCode')"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('charisma.options')" :min-width="70">
            <template slot-scope="props">
              {{ (props.row.options && props.row.options.length) ? props.row.options.length : 0 }}
            </template>
          </el-table-column>
        </data-tables-server>

        <h5 class="charisma-section-title charisma-section-title--logs">{{ $t('charisma.sendHistory') }}</h5>
        <div class="charisma-logs-table-wrap">
          <el-table
            v-loading="loading"
            :data="logs"
            :empty-text="$t('reports.noDataAvailable')"
            class="report-sales"
            style="width: 100%"
          >
            <el-table-column prop="action" :label="$t('general.action')" :min-width="120">
              <template slot-scope="scope">
                {{ getLogActionLabel(scope.row.action) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('charisma.categoryAdministration')" :min-width="140">
              <template slot-scope="scope">
                {{ getLogAdministrationName(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('charisma.logRvc')" :min-width="90">
              <template slot-scope="scope">
                {{ getLogRvcFromDataTo(scope.row.data_to) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('charisma.document')" :min-width="100">
              <template slot-scope="scope">
                <a
                  v-if="hasLogPayload(scope.row.data_to)"
                  class="btn btn-icon btn-info"
                  :title="$t('general.visualize')"
                  @click.prevent="openLogModal(scope.row, 'data_to')"
                >
                  <i class="ti-eye"></i>
                </a>
              </template>
            </el-table-column>
            <el-table-column :label="$t('charisma.resultCharisma')" :min-width="120">
              <template slot-scope="scope">
                <a
                  v-if="hasLogPayload(scope.row.data_from)"
                  class="btn btn-icon btn-info"
                  :title="$t('general.visualize')"
                  @click.prevent="openLogModal(scope.row, 'data_from')"
                >
                  <i class="ti-eye"></i>
                </a>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('charisma.logStatus')"
              :min-width="320"
              class-name="charisma-log-status-cell"
            >
              <template slot-scope="scope">
                <span class="charisma-log-status-text">{{ getLogVerdict(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" :label="$t('charisma.createDate')" :min-width="160">
              <template slot-scope="scope">
                {{ scope.row.created_at ? formatToCompanyTimezone(scope.row.created_at, timezone) : '-' }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
 </template>

<script>
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

export default {
  components: { GeneralTopBar },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    activeRoute () {
      return (this.route && this.route.params) ? this.route : this.$route
    }
  },
  data () {
    return {
      loading: false,
      items: [],
      expandedRowKeys: [],
      modifiedProductsById: {},
      modifiedOptionsByKey: {},
      validationTriggered: false,
      rowsReady: false,
      tableKey: 0,
      categoryAdministrationByKey: {},
      logs: [],
      timezone: null,
      administrations: [],
      integration: null,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        },
        rowKey: 'id',
        expandRowKeys: [],
        rowClassName: ({ row }) => {
          if (!this.rowsReady) return ''
          const hasOptions = row && Array.isArray(row.options) && row.options.length > 0
          return hasOptions ? '' : 'no-expand'
        }
      }
    }
  },
  created () {
    this.timezone = (this.$session.get('selectedCompanyData') || {}).timezone || 'Europe/Bucharest'
    this.fetchItems()
    this.initAdministrations()
  },
  methods: {
    goBackToReport () {
      this.$bus.$emit('refresh')
      this.$bus.$emit('close-modal')
    },
    isCategoryAdminInvalid (row) {
      if (!this.validationTriggered) return false
      const key = this.getCategoryKey(row)
      const val = this.categoryAdministrationByKey[key]
      return val === undefined || val === null || val === ''
    },
    isPosIdMissing (value) {
      if (value === undefined || value === null) return true
      if (typeof value === 'string') return value.trim() === ''
      return false
    },
    isProductPosIdMissing (row) {
      return !row || this.isPosIdMissing(row.c_pos_id)
    },
    isOptionPosIdMissing (option) {
      return !option || this.isPosIdMissing(option.cov_pos_id)
    },
    initAdministrations () {
      const sessionData = this.$session.get('selectedCompanyData') || {}
      if (sessionData['administrations']) {
        this.administrations = sessionData['administrations']
        return
      }
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/administration', 'GET', data, (response) => {
        if (response && response.status && Array.isArray(response.data)) {
          this.administrations = response.data
          sessionData['administrations'] = response.data
          this.$session.set('selectedCompanyData', sessionData)
        } else {
          this.administrations = []
        }
      })
    },
    fetchItems () {
      const orderId = this.activeRoute.params.orderId
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.loading = true
      this.apiRequest(`/reports/v2/charisma/items/${orderId}`, 'GET', data, (response) => {
        if (response && response.status) {
          if (response.data && Array.isArray(response.data.products)) {
            this.items = response.data.products
          } else if (Array.isArray(response.data)) {
            this.items = response.data
          } else {
            this.items = (response.data.products || [])
          }

          this.logs = this.extractLogsFromResponse(response.data)

          // Store integration data if it exists
          if (response.data && response.data.integration) {
            this.integration = response.data.integration
          } else {
            this.integration = null
          }

          this.expandedRowKeys = (this.items || [])
            .filter(p => p && Array.isArray(p.options) && p.options.length > 0)
            .map(p => p.id)
          this.tableOptions.expandRowKeys = this.expandedRowKeys
          // initialize category administration selections from loaded items
          ;(this.items || []).forEach(p => {
            const key = this.getCategoryKey(p)
            if (key === undefined || key === null) return
            const inferred = p.administration_id || null
            if (inferred !== undefined && inferred !== null) {
              this.$set(this.categoryAdministrationByKey, key, inferred)
            }
          })
        } else {
          this.items = []
          this.logs = []
          this.integration = null
        }
        this.$nextTick(() => {
          this.rowsReady = true
          this.loading = false
          this.tableKey = Date.now()
        })
      })
    },
    getCategoryKey (row) {
      if (!row) return undefined

      return row.category_id || row.categoryId || row.category || row.category_name || row.categoryName
    },
    onCategoryAdminChange (row, value) {
      const key = this.getCategoryKey(row)
      if (key === undefined || key === null) return
      this.$set(this.categoryAdministrationByKey, key, value)
      // propagate selection to all rows sharing same category key
      ;(this.items || []).forEach(p => {
        if (this.getCategoryKey(p) === key) {
          this.$set(p, '_category_admin', value)
          // mark product as modified with category and administration info
          const categoryId = p.category_id || p.categoryId || row.category_id || row.categoryId || null
          const updated = Object.assign({}, this.modifiedProductsById[p.id] || {}, {
            id: p.id,
            category_id: categoryId,
            administration_id: value
          })
          this.$set(this.modifiedProductsById, p.id, updated)
        }
      })
    },
    extractLogsFromResponse (data) {
      if (!data) return []
      if (Array.isArray(data.all_logs)) return data.all_logs
      return []
    },
    getLogActionLabel (action) {
      if (action === undefined || action === null || action === '') return '-'
      const i18nKey = 'charisma.logAction.' + action
      const translated = this.$t(i18nKey)
      if (translated !== i18nKey) return translated
      const known = {
        bill: 'charisma.bill',
        invoice: 'charisma.invoice',
        proform: 'charisma.bill',
        proforma: 'charisma.bill'
      }
      const normalized = String(action).toLowerCase()
      if (known[normalized]) return this.$t(known[normalized])
      return String(action)
    },
    getLogAdministrationName (log) {
      if (!log) return '-'
      if (log.administration && log.administration.name) return log.administration.name
      if (log.administration_name) return log.administration_name
      const adminId = log.administration_id != null
        ? log.administration_id
        : (log.administration && log.administration.id)
      if (adminId != null) {
        const found = (this.administrations || []).find(a => a && Number(a.id) === Number(adminId))
        if (found && found.name) return found.name
      }
      return '-'
    },
    getLogPropertyValue (properties, propertyCode) {
      if (!Array.isArray(properties)) return null
      const prop = properties.find((p) => {
        if (!p) return false
        const code = p.propertyCode || p.PropertyCode
        return code === propertyCode
      })
      if (!prop) return null
      const value = prop.propertyValue != null ? prop.propertyValue : prop.PropertyValue
      return value != null && value !== '' ? value : null
    },
    getLogRvcFromDataTo (dataTo) {
      const parsed = this.parseLogPayload(dataTo)
      if (!parsed || parsed._raw) return '-'
      const document = parsed.document || parsed.Document
      if (!document) return '-'
      const details = document.documentDetail || document.DocumentDetail
      if (!Array.isArray(details) || !details.length) return '-'
      const firstDetail = details[0]
      const properties = firstDetail.documentDetailProperty || firstDetail.DocumentDetailProperty
      const rvc = this.getLogPropertyValue(properties, 'RVC')
      return rvc != null ? String(rvc) : '-'
    },
    escapeHtml (value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },
    openLogModal (row, field) {
      if (!row || !this.hasLogPayload(row[field])) return
      const title = field === 'data_from'
        ? this.$t('charisma.resultCharisma')
        : this.$t('charisma.document')
      const content = this.prettyJson(row[field])
      const html = '<div class="charisma-log-swal__scroll">' +
        '<pre class="charisma-log-swal__pre">' + this.escapeHtml(content) + '</pre>' +
        '</div>'
      swal({
        title: title,
        html: html,
        width: '1200px',
        confirmButtonText: 'OK',
        customClass: 'wolt-drive-events-swal'
      })
    },
    isCharismaAlreadySent (type) {
      if (!this.integration) return false
      const proformaStatus = Number(this.integration.charisma_status)
      const invoiceStatus = Number(this.integration.charisma_invoice_status)
      if (type === 1) return proformaStatus === 3
      if (type === 2) return invoiceStatus === 3
      return proformaStatus === 3 || invoiceStatus === 3
    },
    confirmResendIfNeeded (type, onConfirm) {
      if (!this.isCharismaAlreadySent(type)) {
        onConfirm()
        return
      }
      swal({
        title: '',
        text: this.$t('charisma.resendConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel')
      }).then((result) => {
        if (result) onConfirm()
      })
    },
    prettyJson (val) {
      if (val === undefined || val === null || val === '') return ''
      try {
        const parsed = typeof val === 'string' ? JSON.parse(val) : val
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return typeof val === 'string' ? val : JSON.stringify(val)
      }
    },
    parseLogPayload (val) {
      if (val === undefined || val === null || val === '') return null
      if (typeof val === 'object') return val
      try {
        return JSON.parse(val)
      } catch (e) {
        return { _raw: String(val) }
      }
    },
    hasLogPayload (val) {
      if (val === undefined || val === null) return false
      if (Array.isArray(val)) return val.length > 0
      if (typeof val === 'string') {
        const trimmed = val.trim()
        if (!trimmed || trimmed === '[]' || trimmed === '{}') return false
        try {
          const parsed = JSON.parse(trimmed)
          if (Array.isArray(parsed)) return parsed.length > 0
          if (parsed && typeof parsed === 'object') return Object.keys(parsed).length > 0
          return !!parsed
        } catch (e) {
          return true
        }
      }
      if (typeof val === 'object') return Object.keys(val).length > 0
      return true
    },
    getCharismaErrorId (parsed) {
      if (!parsed || parsed._raw) return null
      if (parsed.errorId != null) return parsed.errorId
      if (parsed.ErrorId != null) return parsed.ErrorId
      return null
    },
    hasCharismaBusinessError (parsed) {
      const errorId = this.getCharismaErrorId(parsed)
      if (errorId === undefined || errorId === null || errorId === '') return false
      return Number(errorId) !== 0
    },
    getLogErrorsArray (parsed) {
      if (!parsed || parsed._raw) return []
      const errors = parsed.errors || parsed.Errors
      return Array.isArray(errors) ? errors : []
    },
    getLogErrorText (err) {
      if (err == null) return ''
      if (typeof err === 'string') return err
      return String(err.error || err.Error || err.message || err.Message || '')
    },
    hasDataToMissingPosIdValidationError (dataTo) {
      const parsed = this.parseLogPayload(dataTo)
      if (!parsed || parsed._raw) return false
      return this.getLogErrorsArray(parsed).some((err) => {
        if (!err || typeof err !== 'object') return false
        const msg = this.getLogErrorText(err)
        if (/do not have pos_id/i.test(msg)) return true
        if (Array.isArray(err.product_ids) && err.product_ids.length > 0) return true
        if (Array.isArray(err.company_option_value_ids) && err.company_option_value_ids.length > 0) return true
        return false
      })
    },
    hasDataToMissingCategoryAdministrationError (dataTo) {
      const parsed = this.parseLogPayload(dataTo)
      if (!parsed || parsed._raw) return false
      return this.getLogErrorsArray(parsed).some((err) => {
        const text = this.getLogErrorText(err).toLowerCase()
        return text.includes('categoryadministration') ||
          /getorderjson returned empty for receipt/i.test(text)
      })
    },
    getDataFromAsText (dataFrom) {
      if (dataFrom === undefined || dataFrom === null) return ''
      if (typeof dataFrom === 'string') return dataFrom
      const parsed = this.parseLogPayload(dataFrom)
      if (!parsed) return ''
      if (parsed._raw) return parsed._raw
      if (parsed.message || parsed.Message) return String(parsed.message || parsed.Message)
      return ''
    },
    hasDataFromCurlConnectionError (dataFrom) {
      const text = this.getDataFromAsText(dataFrom).toLowerCase()
      return text.includes('curl error') || text.includes('libcurl')
    },
    getLogErrorsText (val) {
      const parsed = this.parseLogPayload(val)
      if (!parsed || parsed._raw) return ''
      const errors = parsed.errors || parsed.Errors
      if (typeof errors === 'string') return errors
      if (Array.isArray(errors)) {
        return errors.map((err) => this.getLogErrorText(err)).filter(Boolean).join(' ')
      }
      if (errors && typeof errors === 'object') {
        return this.getLogErrorText(errors)
      }
      return ''
    },
    hasOrderNotDeliveredError (val) {
      if (val === undefined || val === null || val === '') return false
      const parts = []
      if (typeof val === 'string') {
        parts.push(val)
      } else {
        const errorsText = this.getLogErrorsText(val)
        if (errorsText) parts.push(errorsText)
        const parsed = this.parseLogPayload(val)
        if (parsed && parsed._raw) parts.push(parsed._raw)
        else parts.push(JSON.stringify(val))
      }
      const text = parts.join(' ').toLowerCase()
      return text.includes('order is not delivered yet') ||
        text.includes('comanda nu a fost livrat')
    },
    normalizeCharismaBusinessDetailMessage (detail) {
      if (detail == null) return ''
      let msg = ''
      if (typeof detail === 'string') {
        msg = detail.trim()
      } else {
        msg = String(
          detail.message || detail.Message ||
          detail.errorMessage || detail.ErrorMessage ||
          detail.detail || detail.Detail ||
          detail.description || detail.Description || ''
        ).trim()
      }
      return msg.replace(/^Eroare validare\s*:?\s*/i, '').trim()
    },
    getCharismaBusinessErrorMessages (dataFrom) {
      const parsed = this.parseLogPayload(dataFrom)
      if (!parsed || !this.hasCharismaBusinessError(parsed)) return null
      const charismaErrorLabel = this.$t('charisma.logVerdictCharismaError')
      const businessErrorLog = parsed.businessErrorLog || parsed.BusinessErrorLog
      const parts = []
      if (businessErrorLog) {
        const header = businessErrorLog.errorHeader || businessErrorLog.ErrorHeader
        if (header) parts.push(String(header).trim())
        const errorDetails = businessErrorLog.errorDetails || businessErrorLog.ErrorDetails
        if (Array.isArray(errorDetails) && errorDetails.length) {
          errorDetails.forEach((detail) => {
            const msg = this.normalizeCharismaBusinessDetailMessage(detail)
            if (msg) parts.push(msg)
          })
        }
      }
      if (!parts.length) return charismaErrorLabel
      return charismaErrorLabel + ': ' + parts.join(' ')
    },
    isLogResponseError (dataFrom) {
      const parsed = this.parseLogPayload(dataFrom)
      if (!parsed) return false
      if (this.hasCharismaBusinessError(parsed)) return true
      if (parsed._raw) {
        const raw = parsed._raw.toLowerCase()
        return raw.includes('error') || raw.includes('exception') || raw.includes('failed') || raw.includes('fail')
      }
      if (parsed.success === false || parsed.Success === false || parsed.isSuccess === false) return true
      if (parsed.error || parsed.Error || parsed.errors || parsed.Errors) return true
      if (parsed.status === 'error' || parsed.Status === 'Error' || parsed.status === 'failed') return true
      if (parsed.HasError === true || parsed.hasError === true) return true
      const msg = parsed.Message || parsed.message || ''
      if (typeof msg === 'string' && /error|eroare|failed|fail/i.test(msg)) return true
      return false
    },
    isLogResponseSuccess (dataFrom) {
      const parsed = this.parseLogPayload(dataFrom)
      if (!parsed) return false
      if (this.hasCharismaBusinessError(parsed)) return false
      if (parsed._raw) return !this.isLogResponseError(dataFrom)
      if (parsed.success === true || parsed.Success === true || parsed.isSuccess === true) return true
      if (parsed.status === 'ok' || parsed.status === 'success' || parsed.Status === 'Success' || parsed.Status === 'OK') return true
      if (parsed.HasError === false && this.hasLogPayload(dataFrom)) return true
      if (!this.isLogResponseError(dataFrom) && Object.keys(parsed).length > 0) return true
      return false
    },
    getLogVerdict (log) {
      if (!log) return this.$t('charisma.logVerdictNoPayload')
      const hasTo = this.hasLogPayload(log.data_to)
      const hasFrom = this.hasLogPayload(log.data_from)
      if (!hasTo && !hasFrom) return this.$t('charisma.logVerdictNoPayload')
      const charismaErrorMessage = this.getCharismaBusinessErrorMessages(log.data_from)
      if (charismaErrorMessage) return charismaErrorMessage
      if (this.hasDataToMissingPosIdValidationError(log.data_to)) {
        return this.$t('charisma.logVerdictMissingPosIds')
      }
      if (this.hasDataToMissingCategoryAdministrationError(log.data_to)) {
        return this.$t('charisma.logVerdictMissingCategoryAdministration')
      }
      if (this.hasOrderNotDeliveredError(log.data_from) || this.hasOrderNotDeliveredError(log.data_to)) {
        return this.$t('charisma.logVerdictOrderNotDelivered')
      }
      if (hasTo && !hasFrom) return this.$t('charisma.logVerdictAwaitingResponse')
      if (this.hasDataFromCurlConnectionError(log.data_from)) {
        return this.$t('charisma.logVerdictConnectionError')
      }
      if (this.isLogResponseError(log.data_from)) return this.$t('charisma.logVerdictError')
      if (this.isLogResponseSuccess(log.data_from)) return this.$t('charisma.logVerdictSuccess')
      return this.$t('charisma.logVerdictUnknown')
    },
    mergeLogsFromSaveResponse (data) {
      const extracted = this.extractLogsFromResponse(data)
      if (extracted.length) {
        this.logs = extracted
      }
    },
    markProductModified (product) {
      if (!product || !product.id) return
      this.$set(this.modifiedProductsById, product.id, {
        id: product.c_id,
        c_pos_id: product.c_pos_id,
        c_external_id: product.c_external_id
      })
    },
    markOptionModified (product, option) {
      if (!product || !product.id || !option || !option.id) return
      const key = `${product.id}:${option.id}`
      this.$set(this.modifiedOptionsByKey, key, {
        product_id: product.id,
        id: option.cov_id,
        pos_id: option.cov_pos_id
      })
    },
    saveDetailsAndSendOrder (type) {
      if (this.loading) {
        return
      }
      // trigger validation styling
      this.validationTriggered = true
      // block save if any required fields are missing
      const hasInvalidCategory = (this.items || []).some(p => this.isCategoryAdminInvalid(p))
      const hasInvalidProductId = (this.items || []).some(p => this.isProductPosIdMissing(p))
      const hasInvalidOption = (this.items || []).some(p => (p.options || []).some(o => this.isOptionPosIdMissing(o)))
      if (hasInvalidCategory || hasInvalidProductId || hasInvalidOption) {
        // this.$notify({ type: 'warning', message: this.$t('general.fillRequiredFields') || 'Please fill all required fields.' })
        swal(
          '',
          this.$t('general.fillRequiredFields'),
          'error'
        )
        return
      }
      this.confirmResendIfNeeded(type, () => {
        this.executeSaveDetailsAndSendOrder(type)
      })
    },
    executeSaveDetailsAndSendOrder (type) {
      const orderId = this.activeRoute.params.orderId
      // Build full payload from all rows and options, regardless of dirty tracking
      const allProducts = (this.items || []).map(p => {
        const categoryId = p.category_id || p.categoryId || null
        const adminId = this.categoryAdministrationByKey[this.getCategoryKey(p)] || p._category_admin || p.administration_id || null
        return {
          id: p.id, // order product id (used by backend for admin/category updates)
          c_pos_id: p.c_pos_id,
          c_external_id: p.c_external_id,
          category_id: categoryId,
          administration_id: adminId
        }
      })
      const allOptions = (this.items || [])
        .reduce((acc, p) => {
          const opts = (p.options || []).map(o => ({
            product_id: p.id,
            id: o.cov_id,
            pos_id: o.cov_pos_id
          }))
          acc.push(...opts)
          return acc
        }, [])

      // if ((!changedProducts || !changedProducts.length) && (!changedOptions || !changedOptions.length)) {
      //   this.$notify({ type: 'info', message: this.$t('general.nothingToSave') || 'Nothing to save.' })
      //   return
      // }

      const payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId,
        products: allProducts,
        options: allOptions,
        type: type
      }
      this.loading = true
      this.apiRequest(`/reports/v2/charisma/items`, 'PUT', payload, (response) => {
        this.loading = false
        if (response && response.status) {
          if (response.data && Array.isArray(response.data.products)) {
            this.items = response.data.products
          } else if (Array.isArray(response.data)) {
            this.items = response.data
          } else {
            this.items = (response.data.products || [])
          }

          this.mergeLogsFromSaveResponse(response.data)

          // Update integration data if it exists in the response
          if (response.data && response.data.integration) {
            this.integration = response.data.integration
          }

          // this.$notify({ type: 'success', message: this.$t('general.success') })
          swal(
            '',
            this.$t('general.success'),
            'success'
          )
          this.modifiedProductsById = {}
          this.modifiedOptionsByKey = {}
        } else {
          // this.$notify({ type: 'error', message: (response && response.message) || (this.$t('general.error') || 'Error') })
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('general.error'),
            'error'
          )
        }
      })
    }
  }
}
</script>

<style>
.options-wrapper {
  margin-left: 20px;
}
.no-expand td.el-table__expand-column .el-table__expand-icon {
  visibility: hidden; /* keep spacing so row layout/padding remains */
}
.no-expand td.el-table__expand-column {
  cursor: default;
}
/* simple invalid border to highlight required fields */
.is-invalid .el-input__inner,
.is-invalid .el-select__inner,
.is-invalid .el-select .el-input__inner,
.is-invalid input,
.is-invalid select,
.el-input.is-invalid .el-input__inner,
.el-select.is-invalid .el-input__inner,
.el-select.is-invalid .el-select__inner {
  border-color: #ff4d4f !important;
  box-shadow: 0 0 0 1px rgba(255,77,79,.3);
}
.charisma-section-title {
  margin: 0 0 12px;
  font-weight: 600;
}
.charisma-section-title--logs {
  margin-top: 24px;
}
.charisma-logs-table-wrap {
  width: 100%;
  overflow-x: auto;
}
.charisma-logs-table-wrap .report-sales .charisma-log-status-cell .cell {
  white-space: normal !important;
  word-break: normal;
  overflow-wrap: normal;
  hyphens: none;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.45;
}
.charisma-logs-table-wrap .report-sales .charisma-log-status-cell .cell .charisma-log-status-text {
  display: block;
  white-space: normal;
  word-break: normal;
  overflow-wrap: normal;
  hyphens: none;
  color: #303133 !important;
  background: transparent !important;
  border-radius: 0;
  padding: 0;
  font-weight: normal;
  font-size: inherit;
}
.wolt-drive-events-swal {
  padding: 18px 22px 14px;
}
.wolt-drive-events-swal .swal2-title {
  margin: 0 0 10px;
}
.wolt-drive-events-swal .swal2-content {
  margin: 0;
  padding: 0;
}
.wolt-drive-events-swal .swal2-actions {
  margin: 14px 0 0;
}
.charisma-log-swal__scroll {
  max-height: 420px;
  overflow-y: auto;
  padding-top: 6px;
  text-align: left;
}
.charisma-log-swal__pre {
  margin: 0;
  padding: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  font-family: monospace;
  text-align: left;
}
</style>





// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/CharismaItems.vue